var _circle, _rect, _path, _rect2, _circle2, _circle3, _circle4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOnlineLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "#DFE3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 17.5,
    width: 125,
    height: 125,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 27.5C17.5 21.9772 21.9772 17.5 27.5 17.5H132.5C138.023 17.5 142.5 21.9772 142.5 27.5V42.5H17.5V27.5Z",
    fill: "#4F75FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 120.336,
    width: 102.5,
    height: 6.32716,
    rx: 3.16358,
    fill: "#DFE3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 2.5,
    fill: "#DFE3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 30,
    r: 2.5,
    fill: "#DFE3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 30,
    r: 2.5,
    fill: "#DFE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3624 101.406C93.0127 104.491 96.5 107.979 99.585 105.629C101.935 102.544 98.4474 99.0568 95.3624 101.406Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2849 102.329C96.6601 101.954 96.8122 101.498 96.6246 101.31C96.437 101.122 95.9808 101.274 95.6056 101.65C95.2304 102.025 95.0783 102.481 95.2659 102.669C95.4535 102.856 95.9097 102.704 96.2849 102.329Z",
    fill: "#101213"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1476 79.4246H106.936",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1221 79.5116H62.9109",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7083 57.7031L70.8143 65.8212",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8723 57.3551L88.7662 65.4732",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6982 101.233L88.5922 93.1149",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5342 101.581L70.6403 93.4629",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7562 65.4936L71.1292 65.4871L70.8503 66.0487L64.4117 79.0127L64.1908 79.4575L64.4117 79.9023L70.7632 92.6923L71.039 93.2475H71.6589H89.0602H89.6896L89.9619 92.6801L96.1393 79.8031L96.3556 79.3523L96.1247 78.9088L89.5122 66.2058L89.2353 65.6738L88.6355 65.6676L71.7562 65.4936Z",
    stroke: "#4F75FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2671 68.7246L72.657 67.9396L73.5334 67.9486",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.167 67.9401L86.5218 68.0674",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8386 68.0858L87.7151 68.0948L88.1198 68.8723",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4532 69.2401L93.0938 78.1548",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2094 78.6497L93.6141 79.4271L93.2349 80.2174",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9554 80.8002L88.6221 89.8331",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4823 90.1245L88.1032 90.9148H87.2267",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6758 90.9148H73.7313",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4559 90.9148H72.5794L72.1896 90.1298",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9021 89.5509L67.4468 80.5792",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3031 80.2898L66.9132 79.5047L67.3031 78.7197",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5394 78.2438L72.1489 68.9625",
    stroke: "#4F75FF",
    strokeWidth: 0.47812,
    strokeMiterlimit: 10,
    strokeDasharray: "0.96 0.96"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9667 70.5904C73.6151 70.5904 75.7619 68.4435 75.7619 65.7952C75.7619 63.1469 73.6151 61 70.9667 61C68.3184 61 66.1715 63.1469 66.1715 65.7952C66.1715 68.4435 68.3184 70.5904 70.9667 70.5904Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9888 63.8173C69.613 63.1931 69.866 62.434 69.5539 62.1219C69.2418 61.8098 68.4827 62.0628 67.8585 62.687C67.2343 63.3112 66.9813 64.0703 67.2934 64.3824C67.6055 64.6945 68.3645 64.4415 68.9888 63.8173Z",
    fill: "#101213"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.061 70.5904C90.7093 70.5904 92.8562 68.4435 92.8562 65.7952C92.8562 63.1469 90.7093 61 88.061 61C85.4126 61 83.2657 63.1469 83.2657 65.7952C83.2657 68.4435 85.4126 70.5904 88.061 70.5904Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.083 63.8173C86.7072 63.1931 86.9602 62.434 86.6481 62.1219C86.336 61.8098 85.577 62.0628 84.9527 62.687C84.3285 63.3112 84.0755 64.0703 84.3876 64.3824C84.6997 64.6945 85.4588 64.4415 86.083 63.8173Z",
    fill: "#101213"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5765 84.2953C98.2248 84.2953 100.372 82.1484 100.372 79.5001C100.372 76.8517 98.2248 74.7048 95.5765 74.7048C92.9281 74.7048 90.7812 76.8517 90.7812 79.5001C90.7812 82.1484 92.9281 84.2953 95.5765 84.2953Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5985 77.5221C94.2227 76.8979 94.4757 76.1388 94.1636 75.8267C93.8515 75.5146 93.0925 75.7676 92.4683 76.3919C91.844 77.0161 91.591 77.7751 91.9031 78.0872C92.2152 78.3993 92.9743 78.1463 93.5985 77.5221Z",
    fill: "#101213"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7775 84.2953C67.4258 84.2953 69.5727 82.1484 69.5727 79.5001C69.5727 76.8517 67.4258 74.7048 64.7775 74.7048C62.1292 74.7048 59.9823 76.8517 59.9823 79.5001C59.9823 82.1484 62.1292 84.2953 64.7775 84.2953Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7996 77.5221C63.4238 76.8979 63.6768 76.1388 63.3647 75.8267C63.0526 75.5146 62.2935 75.7676 61.6693 76.3919C61.0451 77.0161 60.7921 77.7751 61.1042 78.0872C61.4163 78.3993 62.1753 78.1463 62.7996 77.5221Z",
    fill: "#101213"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9667 98C73.6151 98 75.7619 95.8531 75.7619 93.2048C75.7619 90.5564 73.6151 88.4095 70.9667 88.4095C68.3184 88.4095 66.1715 90.5564 66.1715 93.2048C66.1715 95.8531 68.3184 98 70.9667 98Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9888 91.2268C69.613 90.6026 69.866 89.8436 69.5539 89.5314C69.2418 89.2193 68.4827 89.4723 67.8585 90.0966C67.2343 90.7208 66.9813 91.4798 67.2934 91.7919C67.6055 92.104 68.3646 91.851 68.9888 91.2268Z",
    fill: "#101213"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2083 98C90.8566 98 93.0035 95.8531 93.0035 93.2048C93.0035 90.5564 90.8566 88.4095 88.2083 88.4095C85.56 88.4095 83.4131 90.5564 83.4131 93.2048C83.4131 95.8531 85.56 98 88.2083 98Z",
    fill: "#4F75FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2303 91.2268C86.8546 90.6026 87.1076 89.8436 86.7955 89.5314C86.4833 89.2193 85.7243 89.4723 85.1001 90.0966C84.4759 90.7208 84.2229 91.4798 84.535 91.7919C84.8471 92.104 85.6061 91.851 86.2303 91.2268Z",
    fill: "#101213"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M106.412 77.3926C104.063 80.4776 107.55 83.9649 110.635 81.6152C112.985 78.5302 109.497 75.0429 106.412 77.3926Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.335 78.3151C107.71 77.9399 107.862 77.4836 107.674 77.2961C107.487 77.1085 107.031 77.2605 106.655 77.6357C106.28 78.0109 106.128 78.4671 106.316 78.6547C106.503 78.8423 106.96 78.6902 107.335 78.3151Z",
    fill: "#101213"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8833 54.7709C91.5336 57.8559 95.0209 61.3432 98.1059 58.9935C100.456 55.9085 96.9683 52.4212 93.8833 54.7709Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8058 55.6933C95.181 55.3182 95.3331 54.8619 95.1455 54.6743C94.9579 54.4868 94.5017 54.6388 94.1265 55.014C93.7513 55.3892 93.5992 55.8454 93.7868 56.033C93.9744 56.2206 94.4306 56.0685 94.8058 55.6933Z",
    fill: "#101213"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6038 55.3799C59.2541 58.4649 62.7414 61.9522 65.8264 59.6025C68.176 56.5175 64.6887 53.0302 61.6038 55.3799Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5263 56.3024C62.9015 55.9272 63.0535 55.4709 62.8659 55.2834C62.6783 55.0958 62.2221 55.2478 61.8469 55.623C61.4718 55.9982 61.3197 56.4544 61.5073 56.642C61.6949 56.8296 62.1511 56.6775 62.5263 56.3024Z",
    fill: "#101213"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7709 77.3055C47.4212 80.3905 50.9085 83.8778 53.9935 81.5281C56.3431 78.4431 52.8559 74.9559 49.7709 77.3055Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6933 78.228C51.0684 77.8528 51.2205 77.3966 51.0329 77.209C50.8453 77.0214 50.3891 77.1735 50.0139 77.5487C49.6387 77.9239 49.4867 78.3801 49.6743 78.5677C49.8618 78.7553 50.3181 78.6032 50.6933 78.228Z",
    fill: "#101213"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2987 100.623C57.949 103.708 61.4363 107.196 64.5213 104.846C66.871 101.761 63.3837 98.2737 60.2987 100.623Z",
    fill: "#FFC93C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2212 101.546C61.5964 101.171 61.7485 100.714 61.5609 100.527C61.3733 100.339 60.9171 100.491 60.5419 100.867C60.1667 101.242 60.0146 101.698 60.2022 101.886C60.3898 102.073 60.846 101.921 61.2212 101.546Z",
    fill: "#101213"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOnlineLearning);
export default __webpack_public_path__ + "static/media/home_online_learning.921f4d30d11973f646b6426646e0eaff.svg";
export { ForwardRef as ReactComponent };